import {
  combineLatestTyped,
  filterNotUndefined,
  IList
} from 'annotation-tools/utils';
import { Observable, ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { FetchErrorType } from '../../../api/types/common/fetch-error-type';
import { FetchResultType } from '../../../api/types/common/fetch-result';
import { token$ } from '../../auth-state';
import {
  ListWithPromiseState,
  listWithPromiseStateEq
} from './list-with-status';
import { attachPromiseStateToList } from './rxjs-operator/attach-promise-state-to-list';

export const fetchSignalStreamGenerator = () => new ReplaySubject<symbol>(1);

export const fetchListFnGenerator = (
  fetchSignal$: ReplaySubject<symbol>
) => () => {
  fetchSignal$.next(Symbol());
};

export const listStreamGenerator = <T>(
  fetchSignal$: ReplaySubject<symbol>,
  fetchFn: (
    token: string
  ) => Promise<FetchResultType<IList<T>, FetchErrorType<void>>>
): Observable<ListWithPromiseState<T>> =>
  combineLatestTyped(
    token$.pipe(filterNotUndefined()),
    fetchSignal$.asObservable()
  ).pipe(
    debounceTime(100),  // Avoid performance overhead caused by duplicate API requests
    map(([token]) => fetchFn(token)),
    attachPromiseStateToList('mergeMap'),
    distinctUntilChanged(listWithPromiseStateEq),
    shareReplay(1)
  );
